import {DynamicFormService} from '../dynamic-form/dynamic-form.service';
import {DynamicFormEventsService} from './dynamic-form-events.service';
import {DynamicFormValidationService} from '../validation/dynamic-form-validation.service';

export interface DynamicFormReadyEvent {
    dynamicFormService: DynamicFormService;
    dynamicFormEventsService: DynamicFormEventsService;
    dynamicFormValidationService: DynamicFormValidationService;
}
